module.exports = __webpack_public_path__ + "fb825145f045a8695a147162dd57197f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/design_blue.png
// module id = 223
// module chunks = 0